"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customer = require("@/api/customer");
var _skinStatus = require("@/api/skin-status");
var _vuePropertyDecorator = require("vue-property-decorator");
var _depositOrder = require("@/types/depositOrder");
var _ghn = require("@/api/ghn");
var CustomerOrderForm = /*#__PURE__*/function (_Vue) {
  function CustomerOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "checkCustomerMonthBirthday", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "usingCustomerAddress", false);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "skins", []);
    (0, _defineProperty2.default)(_this, "rules", {
      customerId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      addressCityId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      addressDistrictId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      addressWardId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      receiverPhone: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      receiverAddress: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "DepositOrderStatus", _depositOrder.DepositOrderStatus);
    (0, _defineProperty2.default)(_this, "customers", []);
    return _this;
  }
  (0, _inherits2.default)(CustomerOrderForm, _Vue);
  return (0, _createClass2.default)(CustomerOrderForm, [{
    key: "disableForm",
    get: function get() {
      return this.orderStatus == _depositOrder.DepositOrderStatus.Complete || this.disabled;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchCustomers();
      this.fetchCities();
      this.fetchSkins();
    }
  }, {
    key: "handleCreateCustomer",
    value: function handleCreateCustomer() {
      this.$refs.customerModal.handleCreate();
    }
  }, {
    key: "handleChangeUsingAddress",
    value: function handleChangeUsingAddress() {
      if (!this.usingCustomerAddress) {
        this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
          addressCityId: null,
          addressDistrictId: null,
          addressWardId: null
        });
      } else {
        if (this.form.customerId) {
          this.handleChangeCustomer();
        }
      }
    }
  }, {
    key: "watchForm",
    value: function watchForm(val) {}
  }, {
    key: "watchCity",
    value: function watchCity(val) {
      var _this2 = this;
      if (this.form.receiverCityId) {
        this.fetchDistricts();
      }
      var city = this.cities.find(function (e) {
        return e.ProvinceID == _this2.form.receiverCityId;
      });
      this.form.receiverCityName = city && city.ProvinceName;
      this.form.receiverCityCode = city && city.Code;
    }
  }, {
    key: "watchDistrictId",
    value: function watchDistrictId() {
      var _this3 = this;
      if (this.form.receiverDistrictId) {
        this.fetchWards();
      }
      var district = this.districts.find(function (e) {
        return e.DistrictID == _this3.form.receiverDistrictId;
      });
      this.form.receiverDistrictName = district && district.DistrictName;
      this.form.receiverDistrictCode = district && district.Code;
    }
  }, {
    key: "watchWardCode",
    value: function watchWardCode() {
      var _this4 = this;
      var ward = this.wards.find(function (e) {
        return e.WardCode == _this4.form.receiverWardCode;
      });
      this.form.receiverWardName = ward && ward.WardName;
    }
  }, {
    key: "handleChangeDistrict",
    value: function handleChangeDistrict() {
      this.form.receiverWardCode = null;
    }
  }, {
    key: "handleChangeCity",
    value: function handleChangeCity() {
      this.$set(this.form, "receiverDistrictId", null);
      this.$set(this.form, "receiverWardCode", null);
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _ghn.ghnApi.findCity();
            case 2:
              res = _context.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _ghn.ghnApi.findDistrict({
                province_id: this.form.receiverCityId
              });
            case 2:
              res = _context2.sent;
              this.districts = res.data.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _ghn.ghnApi.findWard({
                district_id: this.form.receiverDistrictId
              });
            case 2:
              res = _context3.sent;
              this.wards = res.data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchWards() {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "handleChangeCustomer",
    value: function () {
      var _handleChangeCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var res, customer;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _customer.customerApi.findOne(this.form.customerId);
            case 2:
              res = _context4.sent;
              customer = res.data.customer;
              if (customer) {
                this.$set(this.form, "skinStatusIds", customer.skinStatuses && customer.skinStatuses.map(function (e) {
                  return e.id;
                }));
                this.$set(this.form, "detailCustomer", res.data);
                if (this.usingCustomerAddress) {
                  this.$set(this.form, "receiverCityId", customer.receiverCityId);
                  this.$set(this.form, "receiverDistrictId", customer.receiverDistrictId);
                  this.$set(this.form, "receiverWardCode", customer.receiverWardCode);
                  this.$set(this.form, "receiverName", customer.name);
                  this.$set(this.form, "receiverPhone", customer.phone);
                  this.$set(this.form, "receiverAddress", customer.receiverAddress);
                }
              }
              this.$emit("checkCustomerRank");
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleChangeCustomer() {
        return _handleChangeCustomer.apply(this, arguments);
      }
      return handleChangeCustomer;
    }()
  }, {
    key: "fetchCustomers",
    value: function fetchCustomers() {
      var _this5 = this;
      _customer.customerApi.findAll().then(function (res) {
        _this5.customers = res.data.customers;
      });
    }
  }, {
    key: "fetchSkins",
    value: function fetchSkins() {
      var _this6 = this;
      _skinStatus.skinStatusApi.findAll().then(function (res) {
        _this6.skins = res.data.skinStatuses;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], CustomerOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], CustomerOrderForm.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "checkCustomerMonthBirthday", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "compare", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form")], CustomerOrderForm.prototype, "watchForm", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverCityId", {
  deep: true
})], CustomerOrderForm.prototype, "watchCity", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverDistrictId"), (0, _vuePropertyDecorator.Watch)("districts")], CustomerOrderForm.prototype, "watchDistrictId", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverWardCode"), (0, _vuePropertyDecorator.Watch)("wards")], CustomerOrderForm.prototype, "watchWardCode", null);
CustomerOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerDialog: function CustomerDialog() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/customer/components/CustomerDialog.vue"));
      });
    }
  }
})], CustomerOrderForm);
var _default = exports.default = CustomerOrderForm;